import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Button,
  DialogActions,
  Stack,
} from "@mui/material";
// hooks
import useResponsive from '../../hooks/useResponsive';


export default function CoreTimeIntroDialog({ isOpen, close, goToSet }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={isOpen} onClose={close} fullWidth maxWidth="dg">
      <DialogTitle variant="h5" sx={{ px: { xs: 3, sm: 4 }, py: { xs: 3, sm: 4 } }}>
        코어 타임을 잘 지켜주세요!
      </DialogTitle>
      <DialogContent sx={{ px: { xs: 3, sm: 4 } }}>
        <Typography variant="h6" gutterBottom>
          ☝️ 코어 타임이 무엇인가요?
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary", mb: 4 }}>
          출퇴근 시스템을 이용하기로 약속한 시간이에요.
        </Typography>

        <Typography variant="h6" gutterBottom>
          ⛔  코어 타임을 잘 지켜주세요.
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary", mb: 4 }}>
          코어타임 반복 미준수 시 기업이 업무 불성실로 간주하여 이의 제기 또는 계약 해지의 사유로 삼을 수 있으니 유의하여 주십시오.
        </Typography>

        <Typography variant="h6" gutterBottom>
          ⏰ 시간을 어떻게 설정하면 되요?
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary" }}>
          고정적으로 출근할 수 있는 시간을 설정하면 됩니다. 코어 타임은 변경 즉시 회사에 공유되니, 회사와 상의해서 변경해주세요.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ mx: 1 }}>
        <Stack sx={{ width: 1, justifyContent: "flex-end" }} direction={{ xs: "column-reverse", sm: "row" }} spacing={2}>
          <Button variant="text" fullWidth={!smUp} size="large" sx={{ px: 4 }} onClick={close} >
            취소
          </Button>
          <Button variant="contained" fullWidth={!smUp} size="large" sx={{ px: 3 }} onClick={goToSet} >
            설정하러 가기
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}